import { css } from '@lastbrand/web-ui-styled-system/css'

// Native <button> reset so legacy Button-atom rem SCSS can't balloon under panda.
const sizeChartButtonBaseRaw = css.raw({
  display: 'block',
  width: 'fit-content',
  margin: 0,
  padding: 0,
  cursor: 'pointer',
  appearance: 'none',
  background: 'transparent',
  border: 'none',
  borderBottom: '1px solid token(colors.black)',
  borderRadius: 'radius-none',
  textAlign: 'left',
  textDecoration: 'none',
  color: 'black',
  // Figma ProductPropertyHeader's "Size chart" ButtonText is body/14 on desktop (QA mockup
  // I9346:28523;8151:16342;7800:90994); mobile keeps body-12 (STRFRNT-16751).
  textStyle: 'body-12',
  lg: { textStyle: 'body-14' },
})

export const sizeChartButtonDsClass = css(sizeChartButtonBaseRaw)

export const sizeChartButtonStandaloneDsClass = css(sizeChartButtonBaseRaw, {
  marginBlock: 'space-24',
  marginInline: 0,
})
